import React from 'react'
import { Link } from "react-router-dom";

import error from '../../assets/Images/404.png'

function Error() {
  return (
    <div className='coming d-flex flex-column align-items-center justify-content-center text-center gap-3'>
        <figure>
        <img className='w-100' src={error} alt="error.img" />
        </figure>
        <h2>Oops...</h2>
        <h1>Page Not Found</h1>
        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.</p>
        <Link to = "/" className="btn_1">Back to Home</Link>
    </div>
  )
}

export default Error
